const getFirstBrowserLanguage = () => {
    var url_string = window.location.href; // https://members.test.principal.com.hk/?lang=zh
    var url = new URL(url_string);
    var paramValue = url.searchParams.get("lang");
    return paramValue;
}

export default { getFirstBrowserLanguage }